<template>
    <div class="contact-us full-screen">
        <div class="wrapper wrapper-full-page section content bg-image">
            <div class="container">
                <Keypress :multiple-keys="multiple" key-event="keyup"  @success="checkPoint" @wrong="otherMethod" />
                <b-input hidden v-model="valKey"></b-input>
                <div class="text-center">
                    <img class="mb-1 mt-5" src="@/assets/img/election_logo.png" alt="MUIC">
                </div>
            </div>
            <div class="container-fulid" style="width: 99%;">
                <div class="row">
                    <div class="col-md-8 offset-md-1">
                        <div class="card-custom-chk d-flex justify-content-between align-items-center">
                            <div>
                                <h3 style="color:#433e6d;" class="font-en-chk font-weight-bold mb-0"><i class="fa fa-map-marker" aria-hidden="true"></i> Location</h3>
                                <h5 style="color:#433e6d;font-size:1.9rem;" class="font-thai font-weight-bold mt-0 mb-0">
                                    {{ detailDataToken.location }}
                                </h5>
                            </div>
                            <div>
                                <p class="text-muted font-en-chk mb-0">
                                    <i class="fa fa-users mr-1" aria-hidden="true"></i><i>Total Check-ins</i>
                                </p>
                                <h2 style="color:#433e6d;" class="mt-0 font-en-chk font-weight-bold text-right">{{ countData }} people</h2>
                            </div>
                        </div>
                        <b-card bg-variant="light" class="card-custom-chk mt-3">
                            <b-media no-body>
                                <b-media-aside class="mt-2" vertical-align="center">
                                    <img v-if="objProfileCheck.idstaff === ''" class="thumbnail" src="@/assets/img/avatar.png" style="width:250px;height:300px;" alt="icon_std">
                                    <b-img v-else thumbnail style="width:250px;height:300px;" v-bind:src="`https://icapp.muic.mahidol.ac.th/source/pic/${objProfileCheck.idstaff}.jpg`" alt="muicAvtar" ></b-img>
                                </b-media-aside>
                                <b-media-body class="ml-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h1 
                                                style="font-size:2.2rem;" 
                                                :class="{'text-danger' : objProfileCheck.name === '' , 'text-success' : objProfileCheck.name !== ''}" 
                                                class="font-weight-bold font-en-chk mt-3 mb-0 font-en-chk"
                                            >    
                                                <span v-if="objProfileCheck.name === ''">
                                                    <span :class="{ 'text-success' : detailDataToken.check_type === 'in' , 'text-danger' : detailDataToken.check_type === 'out' }" >Scan your card to {{ detailDataToken.check_type === 'in' ? 'check-in' : 'check-out' }}</span>
                                                </span>
                                                <span v-else>{{ objProfileCheck.name }}</span>
                                            </h1>
                                            <h1 class="font-en-chk mt-1">{{ detailDataToken.check_type === 'in' ? 'check-in' : 'check-out' }} Time : {{ objProfileCheck.time }}</h1>
                                        </div>
                                        <div class="text-center">
                                            <clock size="90px" color="#FFFFFF" border="none" bg="#433e6d"></clock>
                                            <br>
                                            <small class="font-weight-bold font-en-chk">{{ currentTime }}</small>
                                        </div>
                                    </div>
                                    <b-alert class="mt-2" show variant="infoP">
                                        <p class="font-en-chk">Detail:</p>
                                        <hr>
                                        <p class="font-en-chk font-weight-bold mt-1 mb-0 ml-3">
                                            <span class="ml-1">{{ objProfileCheck.department }}</span>
                                        </p>
                                    </b-alert>
                                    <div class="row">
                                        <!-- แบบประเมินความเสี่ยง -->
                                        <!-- <div class="col-md-6">
                                            <div v-if="dataRiskConsent !== ''">
                                                <b-alert 
                                                    class="mt-2" 
                                                    show 
                                                    :variant="dataRiskConsent === 'pass' ? 'success' : dataRiskConsent === 'reject' ? 'danger' :  dataRiskConsent === 'not_found' ? 'warning' : ''"
                                                >
                                                    <h5 class="text-dark font-en-chk font-weight-bold mb-1">Nakhon Pathom's Self-Screening Form</h5>
                                                    <hr class="mt-0 mb-0">
                                                    <h5 class="text-dark font-en-chk mt-0 mb-1">
                                                        <div v-if="dataRiskConsent === 'pass'">
                                                            <i class="fa fa-check fa-lg mr-2" aria-hidden="true" />Pass.
                                                        </div>
                                                        <div v-if="dataRiskConsent === 'reject'">
                                                            <i class="fa fa-times fa-lg mr-2" aria-hidden="true" />Not Pass.
                                                        </div>
                                                        <div v-if="dataRiskConsent === 'not_found'">
                                                            <i class="fa fa-info fa-lg mr-2" aria-hidden="true" />Not Found.
                                                        </div>
                                                    </h5>
                                                </b-alert>
                                            </div>
                                        </div> -->
                                        <!-- ATK -->
                                        <div class="col-md-12">
                                            <div v-if="dataAtk !== ''">
                                                <b-alert 
                                                    class="mt-2" 
                                                    show 
                                                    :variant="diffExpirseDate(dataAtkExpirse) ? dataAtk === 'negative' ? 'success' : dataAtk === 'positive' ? 'danger' :  dataAtk === 'not_found' ? 'danger' : '' : 'danger'"
                                                >
                                                    <h5 class="text-dark font-en-chk font-weight-bold mb-1">Antigen test kit [ ATK ]</h5>
                                                    <hr class="mt-0 mb-0">
                                                    <h5 v-if="diffExpirseDate(dataAtkExpirse)" class="text-dark font-en-chk mt-0 mb-1">
                                                        <div v-if="dataAtk === 'negative'">
                                                            <i class="fa fa-check fa-lg mr-2" aria-hidden="true" />
                                                            Valid until ( {{ moment(moment(dataAtkExpirse).format('YYYY-MM-DD')).add(7, "days") .format("DD-MM-YYYY") }} ) 
                                                        </div>
                                                        <div v-if="dataAtk === 'positive'">
                                                            <i class="fa fa-times fa-lg mr-2" aria-hidden="true" />Positive.
                                                        </div>
                                                        <div v-if="dataAtk === 'not_found'">
                                                            <i class="fa fa-info fa-lg mr-2" aria-hidden="true" />Not Found.
                                                        </div>
                                                    </h5>
                                                    <h5 v-else class="text-dark font-en-chk mt-0 mb-1">
                                                        Your ATK result has expired.
                                                    </h5>
                                                </b-alert>
                                            </div>
                                        </div>
                                        <!-- vaccine -->
                                        <!--  
                                            <div class="col-md-6">
                                                <div v-if="datavacineStatus !== ''">
                                                    <b-alert 
                                                        class="mt-2" 
                                                        show 
                                                        :variant="datavacineStatus === `You're fully vaccinated.` ? 'success' : 'danger'"
                                                    >
                                                        <h5 class="text-dark font-en-chk font-weight-bold mb-1">COVID-19 vaccination status</h5>
                                                        <hr class="mt-0 mb-0">
                                                        <h5 class="text-dark font-en-chk mt-0 mb-1">
                                                            <div v-if="datavacineStatus === 'not_found' || datavacineStatus === 'not_success'">
                                                                <i class="fa fa-info fa-lg mr-2" aria-hidden="true" />Not Found.
                                                            </div>
                                                            <div v-else>
                                                                {{ datavacineStatus }}
                                                            </div>
                                                        </h5>
                                                    </b-alert>
                                                </div>
                                            </div>
                                        -->
                                    </div>
                                </b-media-body>
                            </b-media>
                        </b-card>
                        <div class="card-custom-chk">
                            <b-table small show-empty bordered striped responsive="sm" head-variant="dark" :items="items" :fields="fields"></b-table>
                            <p style="font-weight:100;" class="font-en-chk mb-0 text-muted"><i class="fa fa-phone-square mr-1" aria-hidden="true"></i>To contact the security service, please call 02-7005000 ext. 3511.</p>
                        </div>
                    </div>
                    <div class="col-md-2 text-center">
                        <b-card ref="divQrCard" class="card-custom mt-3">
                            <h3 class="mb-0 font-thai text-danger font-weight-bold blink">
                                You can also use QR Code
                            </h3>
                            <h3 class="mt-0 font-thai font-weight-bold">to {{ detailDataToken.check_type === 'in' ? 'check-in' : 'check-out' }}</h3>
                            <!-- {{ encodeURI('https://sso.muic.io/auth/realms/IC/protocol/openid-connect/logout?redirect_uri='+getUrl) }} -->
                            <!-- <qrcode class="mt-2 mb-20 text-center" :value="encodeURI('https://sso.muic.io/auth/realms/IC/protocol/openid-connect/logout?redirect_uri='+getUrl)" :options="{ width: WidthQr }"></qrcode> -->
                            <h4 class="mt-2 mb-2">with : <i class="fa fa-mobile fa-lg mr-1" aria-hidden="true"></i>Mobile <i class="fa fa-tablet fa-lg ml-2 mr-1" aria-hidden="true"></i>Tablet</h4>
                        </b-card>
                    </div>
                </div>
            </div>
            <!-- loading modal -->
                <b-modal ref="bv-modal-loading" id="bv-modal-loading" hide-footer hide-header-close no-close-on-backdrop>
                    <b-button block variant="primary" disabled>
                        <b-spinner style="width: 3rem; height: 3rem;" small></b-spinner>
                        <h4 class="mt-2 mb-2 text-capitalize">Sending...</h4>
                    </b-button>
                    <hr>
                    <h5 class="font-thai mt-2 mb-2"><i class="fa fa-arrow-circle-right mr-1" aria-hidden="true"></i>Information Technology Section</h5>
                    <h6 class="font-thai mt-2 mb-2 ml-4">หากไม่สามารถแก้ปัญหาได้ กรุณาติดต่อที่ 4208 , 4206 หรือ เจ้าหน้าที่ระบบงานสารสนเทศ</h6>
                </b-modal>
            <!-- loading modal -->
            <!-- modal error card -->
                <b-modal size="lg" ref="bv-modal-errorcard" id="bv-modal-errorcard" hide-footer hide-header-close no-close-on-backdrop>
                    <template v-slot:modal-title>
                        <h5 class="font-thai text-danger font-en-chk font-weight-bold mt-2 mb-0"><i class="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
                            Announcement
                        </h5>
                    </template>
                    <div class="text-center">
                        <img style="width:100%" class="image-responsive mb-5 mt-5" src="@/assets/img/ss.png" alt="MUIC">
                    </div>
                    <!-- <b-alert show variant="danger">
                        <h4 class="font-thai mt-2 mb-2">There is a problem with your card. Please contact the staff to check.</h4>
                        <h5 class="font-thai mt-3 mb-2">บัตรของท่านมีปัญหากรุณาติดต่อเจ้าหน้าที่เพื่อทำการตรวจสอบ</h5>
                    </b-alert> -->
                    <hr>
                    <!-- <h5 class="font-thai mt-2 mb-2"><i class="fa fa-arrow-circle-right mr-1" aria-hidden="true"></i>ติดต่อได้ที่ : Information Technology Section</h5> -->
                </b-modal>
            <!-- modal error card -->
            <!-- modal error 500 server -->
                <b-modal ref="bv-modal-error500" id="bv-modal-error500" hide-footer hide-header-close no-close-on-backdrop>
                    <template v-slot:modal-title>
                        <h5 class="font-thai text-danger font-en-chk font-weight-bold mt-2 mb-0"><i class="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>Please try again</h5>
                    </template>
                    <b-alert show variant="danger">
                        <h4 class="font-thai mt-2 mb-2">Please try to scan your card again.</h4>
                        <h5 class="font-thai mt-3 mb-2">โปรดลองสแกนบัตรของท่านอีกครั้ง</h5>
                    </b-alert>
                    <hr>
                    <h5 class="font-thai mt-2 mb-2"><i class="fa fa-arrow-circle-right mr-1" aria-hidden="true"></i>ติดต่อได้ที่ : Information Technology Section</h5>
                </b-modal>
            <!-- modal error 500 server -->
            <!-- refresh modal -->
                <b-modal ref="bv-modal-refresh" id="bv-modal-refresh" hide-footer hide-header-close no-close-on-backdrop>
                    <b-alert show variant="danger">
                        <h4 class="font-thai mt-2 mb-2">กำลังรีสตาร์ทระบบใหม่ใน {{ sec }} s</h4>
                        <h5 class="font-thai mt-3 mb-2">หากไม่สามารถแก้ปัญหาได้ กรุณาติดต่อที่ 4208 , 4206 หรือ เจ้าหน้าที่ระบบงานสารสนเทศ</h5>
                    </b-alert>
                    <hr>
                    <h5 class="font-thai mt-2 mb-2"><i class="fa fa-arrow-circle-right mr-1" aria-hidden="true"></i>Information Technology Section</h5>
                </b-modal>
            <!-- refresh modal -->
            <!-- modal block -->
                <b-modal size="xl" centered ref="bv-modal-blockcard" id="bv-modal-blockcard" hide-footer hide-header-close no-close-on-backdrop>
                    <template v-slot:modal-title>
                        <h2 class="font-thai text-danger font-en-chk font-weight-bold mt-2 mb-0">
                            <i class="fa fa-exclamation-circle mr-5" aria-hidden="true"></i>STOP !!!</h2>
                    </template>
                    <b-alert show variant="danger" class="text-center">
                        <h2 class="font-thai mt-2 mb-3">You are in the risk group, you are not allowed to enter the premises.</h2>
                        <hr>
                        <h2 class="font-thai mt-3 mb-2">ท่านอยู่ในกลุ่มเสี่ยงไม่อนุญาตให้เข้าสถานที่</h2>
                    </b-alert>
                    <hr>
                    <h3 class="font-thai mt-2 mb-2">โปรดติดต่อ : เจ้าหน้าที่ที่เกี่ยวข้อง / คณะทำงาน คปอ.</h3>
                </b-modal>
            <!-- modal block -->
            <div class="font-thai text-muted pointBottom">
                <i>TokenID : {{ valKey }}</i>
            </div>
            <div class="font-thai text-muted pointBottom rightPosition">
                <b-link @click="refreshPage"><i class="fa fa-refresh fa-lg"></i></b-link>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .blink {
        animation: blinker 1.25s step-start infinite;
    }

    @keyframes blinker {
    50% {
        opacity: 0;
    }
    }
    .card-custom-chk{
        margin-left: -120px;
    }
    .card-custom{
        background-color: white;
        border: 2px solid #433e6d;
        height: 570px;
        margin-right: -120px;
    }
    .rightPosition{
        right: 10px;
    }
    .pointBottom{
        position: absolute;
        bottom: 10px;
    }
    .alert-danger {
        background-color: #ffa8a8;
        color: #000000;
    }
    .alert-infoP {
        background-color: #433e6d;
        color: #ffffff;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en-chk{ font-family: 'Rubik', sans-serif; font-weight: 300; }
    .bg-image {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg-election.png");
    }
</style>

<script>
    import Clock from 'vue-clock2';
    export default {
        components: {
            Keypress: () => import('vue-keypress'),
            Clock
        },
        data() {
            return {
                fields: [
                    {
                        sortable: true, 
                        key: 'c', 
                        label: 'ID',
                        class:'text-center',
                    },
                    {
                        sortable: true, 
                        key: 'c0', 
                        label: 'Name',
                    },
                    {
                        sortable: true, 
                        key: 'c1', 
                        label: 'Location',
                    },
                    {
                        sortable: true, 
                        key: 'c2', 
                        label: 'Building',
                    },
                    {
                        sortable: true, 
                        key: 'c3', 
                        label: 'Device',
                        class:'text-center',
                    },
                    {
                        sortable: true, 
                        key: 'c4', 
                        label: 'Type',
                        class:'text-center',
                    },
                    {
                        sortable: true, 
                        key: 'c5', 
                        label: 'Time',
                    },
                ],
                items: [],
                detailDataToken:[],
                valKey: '',
                objProfileCheck:{
                    idstaff:'',
                    name: '',
                    department: '',
                    time:'',
                },
                // 
                currentTime:null,
                valTemp: 'Key name',
                multiple: [
                    {
                        keyCode: 13, // Enter
                        modifiers: [],
                        preventDefault: true,
                    },
                ],
                timeStart: this.moment().format('YYYY-MM-DD'),
                timeEnd: this.moment().add(1, 'days').format('YYYY-MM-DD'),
                countData: 0,
                hou: 0,
                sec: 5,
                WidthQr:0,
                dataRiskConsent: '',
                dataAtk: '',
                dataAtkExpirse: '',
                datavacineStatus: '',
                dataBlacklist: []
            }
        },
        computed: {
            getTokenUrl(){
                return typeof(this.$route.query.token) === "undefined" || this.$route.query.token === "" ?  this.$router.push("/notfound").catch(err => {}) : this.$route.query.token
            },
            getUrl(){
                // var currentUrl = `${window.location.origin}/#/qrcheckpoint?position=${this.getPosition}&type=${this.getType}`;
                var currentUrl = `${window.location.origin}/#/qrcheckpoint?token=${this.getTokenUrl}`;
                return currentUrl
            },
            // getType(){ return this.$route.query.type === "out" ?  'out' : 'in' },
            // getPosition(){ return typeof(this.$route.query.position) === "undefined" || this.$route.query.position === "" ?  this.$router.push("/foundpage").catch(err => {}) : this.$route.query.position },
        },
        mounted(){
            this.callTokenDetail()
            // this.countPeople()
            this.showModal()
            this.setWidthQr()
        },
        methods: {
            setWidthQr(){ 
                this.WidthQr = this.$refs['divQrCard'].clientWidth - 25
            },
            async callTokenDetail(){
                try {
                    const res = await this.$http.get(`/checkcovid19/location/?token=${this.getTokenUrl}`)
                    this.detailDataToken = res.data
                } catch (error) {}
            },
            refreshPage(){
                // this.showModalRefresh()
                // setInterval(() => 
                //     { 
                //         if(this.sec <= 0)
                //         {
                //             // this.hideModalRefresh()
                //             location.reload()
                //         }
                //         else { this.sec-- }
                //     }
                // , 1 * 1000)
                // if(this.items.length !== 0){ 
                //     this.clearDataObj() 
                //     // console.log("clear")
                // }
                this.countPeople()
            },
            updateCurrentTime() {
                this.currentTime = this.moment().format('LTS');
            },
            showModal() {
                this.$refs['bv-modal-errorcard'].show() 
            },
            hideModal() {
                this.$refs['bv-modal-errorcard'].hide() 
            },
            // Loading
                showModalLoading() {
                    this.$refs['bv-modal-loading'].show() 
                },
                hideModalLoading() {
                    this.$refs['bv-modal-loading'].hide() 
                },
            // 
            // refresh
                showModalRefresh() {
                    this.$refs['bv-modal-refresh'].show() 
                },
                hideModalRefresh() {
                    this.$refs['bv-modal-refresh'].hide() 
                },
            // 
            // 500
                showModal500() {
                    this.$refs['bv-modal-error500'].show() 
                },
                hideModal500() {
                    this.$refs['bv-modal-error500'].hide() 
                },
            // 500
            // block
                showModalBlock(){
                    this.$refs['bv-modal-blockcard'].show() 
                },
                hideModalBlock(){
                    this.$refs['bv-modal-blockcard'].hide() 
                },
            async checkPoint(response) {
                // this.showModalLoading()
                // this.items = []
                // this.dataRiskConsent = ''
                // this.dataAtk = ''
                // this.dataAtkExpirse = ''
                // this.datavacineStatus = ''
                // this.dataBlacklist = []
                // // this.valTemp = this.valKey
                // // call api
                //     try {
                //         if(this.detailDataToken.check_type === 'out'){
                //             var sendId = this.valKey+','
                //         }else{
                //             var sendId = this.valKey
                //         }
                //         const res = await this.$http.get(`/checkcovid19/?staff_id=${sendId}&token=${this.getTokenUrl}`)
                //         // const res = await this.$http.get(`/checkcovid19/?staff_id=${this.valKey}&location=${this.getPosition}&type=${this.getType}`)
                //         this.valKey = ''
                //         if(res.status === 200){
                //             // check survey risk
                //                 // try {
                //                 //     const res_survey = await this.$http.get(`/checkcovid19/survey/${res.data[0].staff_id}/check/`)
                //                 //     if(res_survey.status === 200){
                //                 //         this.dataRiskConsent = res_survey.data.status
                //                 //     }else if(res_survey.status === 204){
                //                 //          this.dataRiskConsent = 'not_found'
                //                 //     }else{
                //                 //         throw { res_survey }
                //                 //     }
                //                 // } catch (error) {
                //                 //     this.dataRiskConsent = 'not_success'
                //                 // }
                //             // check survey risk
                //             // check atk
                //                 try {
                //                     const res_Atk = await this.$http.get(`/checkcovid19/atk/${res.data[0].staff_id}/check/`)
                //                     if(res_Atk.status === 200){
                //                         this.dataAtk = res_Atk.data.result
                //                         this.dataAtkExpirse = res_Atk.data.check_date
                //                     }else if(res_Atk.status === 204){
                //                          this.dataAtk = 'not_found'
                //                     }else{
                //                         throw { res_Atk }
                //                     }
                //                 } catch (error) {
                //                     this.dataAtk = 'not_success'
                //                 }
                //             // chk atk
                //             // check vaccine
                //                 // try {
                //                 //     const res_Vac = await this.$http.get(`/checkcovid19/vaccine/${res.data[0].staff_id}/check/`)
                //                 //     if(res_Vac.status === 200){
                //                 //         this.datavacineStatus = res_Vac.data.status_detail
                //                 //     }else if(res_Vac.status === 204){
                //                 //         this.datavacineStatus = 'not_found'
                //                 //     }else{
                //                 //         throw { res_Vac }
                //                 //     }
                //                 // } catch (error) {
                //                 //     this.datavacineStatus = 'not_success'
                //                 // }
                //             // check vaccine
                //             // check blacklist dataBlacklist 
                //                 try {
                //                     const resBlock = await this.$http.get(`/checkcovid19/blacklist/${res.data[0].staff_id}/check/`)
                //                     if(resBlock.status === 200){
                //                         this.dataBlacklist.push(resBlock.data)
                //                         this.showModalBlock()
                //                     }else if(res_Vac.status === 204){
                //                         this.dataBlacklist = []
                //                     }else{
                //                         throw { resBlock }
                //                     }
                //                 } catch (error) {
                //                     this.dataBlacklist = []
                //                 }
                //             // check blacklist
                //             this.hideModalLoading()
                //             // console.log(res.data)
                //             this.objProfileCheck.idstaff = res.data[0].staff_id
                //             this.objProfileCheck.name = res.data[0].staff_name
                //             this.objProfileCheck.department = res.data[0].staff_department
                //             this.objProfileCheck.time = this.moment(res.data[0].created_at).format('LTS')
                //             // 
                //             this.items = res.data.map(item => {
                //                 return {
                //                     'id': item.id,
                //                     'c': item.staff_id,
                //                     'c0': item.staff_name,
                //                     'c1': item.location_detail.location, 
                //                     'c2': item.location_detail.building,
                //                     'c3': item.input_type,
                //                     'c4': item.location_detail.check_type,
                //                     'c5': this.moment(item.created_at).format('LLLL'),
                //                 }
                //             })
                //             this.items.sort((a, b) =>{ return b.id - a.id; });
                //             // countData
                //             this.countPeople()
                //             // console.log(this.items)
                //             // clear
                //             setTimeout( ()=> 
                //                 this.clearDataObj()
                //             , 5000);
                //         }else{
                //             this.hideModalLoading()
                //             this.showModal()
                //             this.clearDataObj()
                //             setTimeout( ()=> 
                //                 this.hideModal()
                //             , 5000);
                //         }
                //     } catch (error) {
                //         this.hideModalLoading()
                //         this.showModal500()
                //         this.clearDataObj()
                //         setTimeout( ()=> 
                //             this.hideModal500()
                //         , 5000);
                //     } 
                // // call api
            },
            clearDataObj(){
                this.dataAtk = ''
                this.dataBlacklist = ''
                this.dataRiskConsent = ''
                this.datavacineStatus = ''
                this.items = []
                this.objProfileCheck.idstaff = ''
                this.objProfileCheck.name = ''
                this.objProfileCheck.department = ''
                this.objProfileCheck.time = ''
                this.valKey = ''
                this.hideModalBlock()
            },
            otherMethod(response){
                // console.log(response.event.keyCode)
                if(response.event.keyCode >= 48 && response.event.keyCode <= 57){
                    var temp = response.event.keyCode-48
                    this.valKey += `${temp}`
                }else if(response.event.keyCode >= 96 && response.event.keyCode <= 105){
                    var temp = response.event.keyCode-96
                    this.valKey += `${temp}`
                }else if(response.event.keyCode === 8 || response.event.keyCode === 46){
                    this.valKey = this.valKey.substring(0, this.valKey.length - 1);
                }else if(response.event.keyCode == 188){
                    this.valKey = this.valKey+','
                }
            },
            async countPeople(){
                // const resCount =  await this.$http.get(`/checkcovid19/counter/?token=${this.getTokenUrl}&timestart=${this.timeStart}&timeend=${this.timeEnd}`)
                // if (resCount.status === 200) {
                //     const resCountIn =  resCount.data.in
                //     const resCountOut =  resCount.data.out
                //     this.countData = 0
                //     for (let index = 0; index < resCountIn.length; index++) {
                //         var item = resCountOut.find(item => item.staff_id === resCountIn[index].staff_id);
                //         if(typeof(item) !== "undefined"){
                //             if(resCountIn[index].count_amount > item.count_amount){
                //                 this.countData++ 
                //             }
                //         }else{
                //             this.countData++
                //         }
                //     }
                // }else{
                //     this.countData = 0
                // }
            },
            diffExpirseDate(testDate) {
                let formatTestDate = this.moment(testDate).format("YYYY-MM-DD");
                let weekLimit = this.moment(formatTestDate)
                    .add(7, "days")
                    .format("YYYY-MM-DD");
                let todayNow = this.moment().format("YYYY-MM-DD");
                // console.log(weekLimit)
                // console.log(formatTestDate)
                if (this.moment(weekLimit).isBefore(todayNow)) {
                    return false;
                } else {
                    return true;
                }
            },
        },
        created() {
            this.currentTime = this.moment().format('LTS');
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
            setInterval(() => { this.countPeople() }, 1 * 5000);
        }, 
    }
</script>